/**
 * ==========================================
 * Custom Theme JavaScript
 * ==========================================
 */

// ==========================================
// INITIALIZE
// ==========================================

initKachingUpsell();
initQikifyCountdown();
initCustomMenus();

// ==========================================
// Kaching Upsell - Hide Out of Stock Items
// ==========================================

function initKachingUpsell() {
  scanUpsells();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        if (node.matches(".kaching-product-upsell-item")) {
          hideOutOfStockItem(node);
        }

        scanUpsells(node);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function hideOutOfStockItem(item) {
  // Prevent processing the same item multiple times
  if (item.dataset.oosChecked) return;
  item.dataset.oosChecked = "true";

  const button = item.querySelector(
    ".kaching-product-upsell-item__add-to-cart"
  );

  if (!button) return;

  const isOutOfStock =
    button.disabled ||
    button.textContent.trim().toLowerCase() === "out of stock";

  if (isOutOfStock) {
    item.style.display = "none";
  }
}

function scanUpsells(root = document) {
  root
    .querySelectorAll(".kaching-product-upsell-item")
    .forEach(hideOutOfStockItem);
}


// ==========================================
// Qikify Countdown Updates
// ==========================================

const BREAKPOINT = 767;
const isProductPage = window.location.pathname.startsWith("/products/");

function initQikifyCountdown() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupQikifyCountdown);
  } else {
    setupQikifyCountdown();
  }
}

function setupQikifyCountdown() {
  if (document.querySelector(".qsk-promobar__message")) {
    handleQikifyResize();
    window.addEventListener("resize", handleQikifyResize);
    return;
  }

  const promoObserver = new MutationObserver(() => {
    if (document.querySelector(".qsk-promobar__message")) {
      promoObserver.disconnect();

      handleQikifyResize();
      window.addEventListener("resize", handleQikifyResize);
    }
  });

  promoObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function handleQikifyResize() {
  updatePromoText();
  overrideQikifyButton();
  updateMobileVisibility();
  updateBodyPadding();
  addCustomLinks();
  addTrackOrder();

  const promoBar = document.querySelector(".qsk-promobar");
  if (promoBar) {
    promoBar.classList.add("modified");
  }
}

function overrideQikifyButton() {
  if (!window.countdownSettings || !window.countdownSettings.buttonUrl) return;

  const btn = document.querySelector(".qsk-promobar__button");
  if (!btn || btn.dataset.customUrlApplied) return;

  btn.dataset.customUrlApplied = "true";
  btn.addEventListener(
    "click",
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      window.location.href = window.countdownSettings.buttonUrl;
    },
    true
  );
}

function updatePromoText() {
  const promo = document.querySelector(".qsk-promobar__message");

  if (!promo || !window.countdownSettings) return;

  const isMobile = window.innerWidth <= BREAKPOINT;
  const settings = window.countdownSettings;

  promo.textContent = isProductPage
    ? isMobile
      ? settings.pdpMobile
      : settings.pdpDesktop
    : isMobile
      ? settings.mobile
      : settings.desktop;

  updateMobileVisibility();

  requestAnimationFrame(updateBodyPadding);
}

function updateMobileVisibility() {
  const isMobile = window.innerWidth <= BREAKPOINT;

  document
    .querySelectorAll(".qsk-promobar__c-unit")
    .forEach((unit) => {
      unit.style.display = isMobile ? "none" : "";
    });
}

function updateBodyPadding() {
  const bar = document.querySelector(".qsk-promobar__single-bar");

  if (!bar) return;

  requestAnimationFrame(() => {
    document.body.style.paddingTop = `${bar.offsetHeight}px`;
  });
}

function addCustomLinks() {
  const promoBar = document.querySelector('.qsk-promobar__single-bar');
  if (!promoBar || promoBar.querySelector('.qsk-promobar .custom-links')) {
    return;
  }

  const customLinks = document.createElement('div');
  customLinks.className = 'custom-links hidden-mobile';
  customLinks.innerHTML = `
    <a href="https://oonogear.affiliatery.staqlab.com/partner/signIn" target="_blank" class="custom-link" title="Affiliate">
      <svg fill="#d6d6d6" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px" viewBox="0 0 47 47" xml:space="preserve">
        <g>
          <g id="Layer_1_110_">
            <g>
              <path d="M17.567,15.938l-2.859-2.702c0.333-0.605,0.539-1.29,0.539-2.029c0-2.342-1.897-4.239-4.24-4.239
                c-2.343,0-4.243,1.896-4.243,4.239c0,2.343,1.9,4.241,4.243,4.241c0.826,0,1.59-0.246,2.242-0.654l2.855,2.699
                C16.536,16.922,17.023,16.399,17.567,15.938z"></path>
              <path d="M29.66,15.6l3.799-6.393c0.374,0.107,0.762,0.184,1.169,0.184c2.347,0,4.244-1.898,4.244-4.241
                c0-2.342-1.897-4.239-4.244-4.239c-2.343,0-4.239,1.896-4.239,4.239c0,1.163,0.469,2.214,1.227,2.981l-3.787,6.375
                C28.48,14.801,29.094,15.169,29.66,15.6z"></path>
              <path d="M42.762,20.952c-1.824,0-3.369,1.159-3.968,2.775l-5.278-0.521c0,0.04,0.006,0.078,0.006,0.117
                c0,0.688-0.076,1.36-0.213,2.009l5.276,0.521c0.319,2.024,2.062,3.576,4.177,3.576c2.342,0,4.238-1.896,4.238-4.238
                C47,22.85,45.104,20.952,42.762,20.952z"></path>
              <path d="M28.197,37.624l-1.18-5.156c-0.666,0.232-1.359,0.398-2.082,0.481l1.182,5.157c-1.355,0.709-2.29,2.11-2.29,3.746
                c0,2.342,1.896,4.237,4.243,4.237c2.342,0,4.238-1.896,4.238-4.237C32.311,39.553,30.479,37.692,28.197,37.624z"></path>
              <path d="M14.357,25.37l-6.57,2.201c-0.758-1.158-2.063-1.926-3.548-1.926C1.896,25.645,0,27.542,0,29.884
                c0,2.345,1.896,4.242,4.239,4.242c2.341,0,4.242-1.897,4.242-4.242c0-0.098-0.021-0.188-0.029-0.284l6.591-2.207
                C14.746,26.752,14.51,26.077,14.357,25.37z"></path>
              <circle cx="23.83" cy="23.323" r="7.271"></circle>
            </g>
          </g>
        </g>
      </svg>
      <span>Affiliate</span>
    </a>
    <a href="/pages/exclusive-discounts" class="custom-link" title="Keyworker">
      <svg fill="#d6d6d6" width="16px" height="16px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Layer_1"></g>
        <g id="Layer_2">
          <g>
            <polygon fill="none" points="    2,20 18,4 28,4 28,14 12,30   " stroke="#d6d6d6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></polygon>
            <circle cx="23" cy="9" fill="none" r="2" stroke="#d6d6d6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></circle>
            <line fill="none" stroke="#d6d6d6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="24" x2="30" y1="8" y2="2"></line>
            <line fill="none" stroke="#d6d6d6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="17" x2="9" y1="11" y2="19"></line>
            <line fill="none" stroke="#d6d6d6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="21" x2="17" y1="15" y2="19"></line>
          </g>
        </g>
      </svg>
      <span>Keyworker</span>
    </a>
  `;

  promoBar.prepend(customLinks);
}

function addTrackOrder() {
  const promoBar = document.querySelector('.qsk-promobar__single-bar');
  if (!promoBar || promoBar.querySelector('.track-order')) {
    return;
  }

  const trackOrder = document.createElement('div');
  trackOrder.className = 'track-order';
  trackOrder.innerHTML = `
    <a href="/pages/contact/?s=bulk-order" class="custom-link bulk-order-link" aria-label="Bulk Order" title="Bulk Order">
      <svg width="20px" height="20px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 13V22M12.5 13L4.5 8M12.5 13L20.5 8M8.5 5.5L16.5 10.5M4.5 8L12.5 3L20.5 8V17L12.5 22L4.5 17V8Z" stroke="#121923" stroke-width="1.2"/>
      </svg>
      <span>Bulk Order</span>
    </a>
    <a href="/apps/track-order" class="custom-link" aria-label="Track Order" title="Track Order">
      <svg fill="#d6d6d6" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 5h11v10H3zM14 8h4l3 3v4h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="none" stroke="#d6d6d6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Track Order</span>
    </a>
  `;

  promoBar.append(trackOrder);
}

function handleContactUrlParams() {
  if (!window.location.pathname.includes('/pages/contact')) return;
  const urlParams = new URLSearchParams(window.location.search);
  const subject = urlParams.get('s');
  if (subject === 'bulk-order') {
    const categorySelect = document.querySelector('select[name="contact[Enquiry Category]"]');
    if (categorySelect) {
      for (let option of categorySelect.options) {
        if (option.value === 'Wholesale or bulk orders') {
          categorySelect.value = option.value;
          break;
        }
      }
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", handleContactUrlParams);
} else {
  handleContactUrlParams();
}

// ==========================================
// Custom Navigation Menus
// ==========================================

function initCustomMenus() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupCustomMenus);
  } else {
    setupCustomMenus();
  }
}

function setupCustomMenus() {
  const menus = [
    {
      selector:
        '.site-nav__details summary[data-link="/collections/featured"]',
      settings: window.featuredMenuSettings,
      className: "featured-custom-menu",
      addViewAll: true,
      viewAllText: "All Featured",
      itemClassName: "featured-all-item",
    },
    {
      selector:
        '.site-nav__details summary[data-link="/collections/backpacks"]',
      settings: window.bagsMenuSettings,
      className: "packs-custom-menu",
      addViewAll: true,
      viewAllText: "All Bags",
      itemClassName: "bags-all-item",
    },
    {
      selector:
        '.site-nav__details summary[data-link^="/collections/accessories"]',
      settings: window.accessoriesMenuSettings,
      className: "accessories-custom-menu",
      addViewAll: true,
      viewAllText: "All Accessories",
      itemClassName: "accessories-all-item",
    },
  ];

  menus.forEach((menuConfig) => {
    if (!menuConfig.settings?.enabled) return;

    const menu = document
      .querySelector(menuConfig.selector)
      ?.closest(".site-nav__details");

    if (!menu) return;

    addMenuImages(menu, menuConfig.settings);

    if (menuConfig.addViewAll) {
      addViewAllItem(
        menu,
        menuConfig.viewAllText || "View All",
        menuConfig.itemClassName || "accessories-all-item"
      );
    }

    setupMenuHover(menu);
    menu.classList.add(menuConfig.className);
  });
}

function addMenuImages(menu, settings) {
  const menuItems = menu.querySelectorAll(
    ".site-nav__dropdown-link--second-level"
  );

  const settingsItems = settings?.items || [];

  menuItems.forEach((menuItem) => {
    if (menuItem.dataset.customImageAdded) return;

    const menuName = normalizeMenuName(menuItem.textContent);

    const matchingItem = settingsItems.find(
      (item) =>
        item.name &&
        item.image &&
        normalizeMenuName(item.name) === menuName
    );

    if (!matchingItem) return;

    const image = document.createElement("img");

    image.src = matchingItem.image;
    image.alt = menuItem.textContent.trim();
    image.className = "custom-menu-image";

    menuItem.classList.add("custom-menu-item");
    menuItem.prepend(image);

    menuItem.dataset.customImageAdded = "true";
  });
}

function addViewAllItem(
  menu,
  viewAllText = "View All",
  itemClassName = ""
) {
  const dropdown = menu.querySelector(".site-nav__dropdown");

  if (!dropdown) return;

  // Prevent adding it more than once
  if (dropdown.querySelector(`.${itemClassName}`)) return;

  const summary = menu.querySelector("summary");
  const parentLink = summary?.dataset.link;

  if (!parentLink) return;

  const listItem = document.createElement("li");
  listItem.className = `custom-menu-view-all ${itemClassName}`;

  const link = document.createElement("a");

  link.href = parentLink;
  link.className =
    "site-nav__dropdown-link site-nav__dropdown-link--second-level custom-menu-item custom-menu-view-all-link";

  link.innerHTML = `<svg class="custom-menu-icon" fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g id="Circle_Plus" data-name="Circle Plus">
        <g>
          <path d="M15,12.5H12.5V15a.5.5,0,0,1-1,0V12.5H9a.5.5,0,0,1,0-1h2.5V9a.5.5,0,0,1,1,0v2.5H15A.5.5,0,0,1,15,12.5Z"/>
          <path d="M12,21.932A9.934,9.934,0,1,1,21.932,12,9.944,9.944,0,0,1,12,21.932ZM12,3.065A8.934,8.934,0,1,0,20.932,12,8.944,8.944,0,0,0,12,3.065Z"/>
        </g>
      </g>
    </svg>
    <span>${viewAllText}</span>`;

  listItem.appendChild(link);
  dropdown.appendChild(listItem);
}

function normalizeMenuName(name) {
  return name.trim().replace(/\s+/g, " ").toLowerCase();
}

function positionCustomMenu(menu) {
  const dropdown = menu.querySelector(".site-nav__dropdown");

  if (!dropdown) return;

  const menuPosition = menu.getBoundingClientRect();

  dropdown.style.left = `${-menuPosition.left}px`;
  dropdown.style.width = `${window.innerWidth}px`;
}

function setupMenuHover(menu) {
  const summary = menu.querySelector("summary");

  if (!summary) return;

  summary.addEventListener("click", (event) => {
    event.preventDefault();
  });

  menu.addEventListener("mouseenter", () => {
    positionCustomMenu(menu);

    menu.setAttribute("open", "");
    summary.setAttribute("aria-expanded", "true");
  });

  menu.addEventListener("mouseleave", () => {
    menu.removeAttribute("open");
    summary.setAttribute("aria-expanded", "false");
  });

  window.addEventListener("resize", () => {
    if (menu.hasAttribute("open")) {
      positionCustomMenu(menu);
    }
  });
}
